import { render } from "./VnAbout.vue?vue&type=template&id=d055f13c&scoped=true"
const script = {}

import "./VnAbout.vue?vue&type=style&index=0&id=d055f13c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d055f13c"

export default script